import { useState, useEffect, useRef, Fragment } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  getAuth,
  signInWithCustomToken,
  db,
  doc,
  getDoc,
  updateDoc,
  Timestamp,
} from "../firebase";
import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
//import Select from "../components/Select";
import Radios from "../components/Radios";
import Checkboxes from "../components/Checkboxes";
import Msg from "../components/Msg";
import Submit from "../components/Submit";
import Nav from "./Nav";

const EmailSend = () => {
  const [user, setUser] = useState({});
  const [html, setHtml] = useState("");
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({});
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const formElement = useRef(null);
  const history = useHistory();

  const emailId = getValFromLS("emailId", true)
    ? getValFromLS("emailId", true)
    : "";

  const token = getValFromLS("vtoUserToken")
    ? getValFromLS("vtoUserToken")
    : "";

  useEffect(() => {
    const init = async () => {
      const url = new URL(`${API_URL}/admin/emailSendInit`);
      const params = {
        token,
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();

        if (emailId) {
          if (json && json.resp === 1) {
            setUser({ ...json.user });
            setNames({ replyto: json.user.email, emails: json.user.email });
            scroll();
            handleFirebAuth(json.firebToken);
          } else {
            setAlert({
              type: json.resp === 2 ? "notice" : "error",
              text: json.text,
            });
          }
        } else {
          history.push("/admin/email");
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  const handleFirebAuth = (token) => {
    const auth = getAuth();
    signInWithCustomToken(auth, token)
      .then(async (userCredential) => {
        // Signed in userCredential.user;

        const docRef = doc(db, "bfcEmails", emailId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setHtml(docSnap.data().html);
          setAlert({});
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        setAlert({
          type: "error",
          text: `Error ${error.message} (${error.code}).`,
        });
      });
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleCheckboxes = (name, checked, value) => {
    let newValue = 0;
    if (checked) {
      newValue = 1;
    }
    //setNames((names) => ({ ...names, [name]: newValue }));

    if (
      name === "contacts" ||
      name === "mon" ||
      name === "wed" ||
      name === "sat"
    ) {
      setNames((names) => ({
        ...names,
        [name]: newValue,
        recipients: undefined,
      }));

      /*
      setMsg({
        type: "working",
        text: "",
      });
      handleRetrieveRecipients(name, newValue);
      */
    }
  };

  /*
    const handleRetrieveRecipients = async (name, newValue) => {
      const url = new URL(`${API_URL}/admin/emailSendRecipientsInit`);
      const params = {
        token,
        action: names.action,
        contacts:
          name === "contacts" && newValue ? "1" : names.contacts ? "1" : "0",
        mon: name === "mon" && newValue ? "1" : names.mon ? "1" : "0",
        wed: name === "wed" && newValue ? "1" : names.wed ? "1" : "0",
        sat: name === "sat" && newValue ? "1" : names.sat ? "1" : "0",
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();

        if (json && json.resp === 1 && json.recipients > 0) {
          handleUpdate("recipients", json.recipients);
          setMsg({});
        } else if (json && json.resp === 1) {
          handleUpdate("recipients", json.recipients);
          setMsg({
            type: "error",
            text: "No recipients found for that selection.",
          });
        } else {
          setAlert({
            type: json.resp === 2 ? "notice" : "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };
  */

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/admin/emailSend`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append("html", html);
    data.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (names.action === "self") {
          setMsg({
            type: "success",
            text: json.text,
          });
        } else {
          const docRef = doc(db, "bfcEmails", emailId);
          await updateDoc(docRef, {
            sent: true,
            recipients: json.recipients,
            subject: names.subject,
            replyto: names.replyto,
            lists: {
              contacts: names.contacts ? true : false,
              mon: names.mon ? true : false,
              wed: names.wed ? true : false,
              sat: names.sat ? true : false,
            },
            date: Timestamp.fromDate(new Date(json.date)),
          });

          setValToLS("emailId", null, true);

          history.push("/admin/email", {
            replace: true,
            state: {
              message: {
                type: "success",
                text: json.text,
              },
            },
          });
        }
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <Fragment>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <Fragment>
          <div id="left-column">
            <Hdg section="Admin Send Email" />

            <p>
              Use this form to send emails to Pro-Am main contacts and/or
              participants.
            </p>

            <div className="spacer"></div>

            <form
              ref={formElement}
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <h4 style={{ marginBottom: "12.5px" }}>ID: {emailId}</h4>

              <iframe
                title="email-preview"
                className="email-preview"
                marginWidth="0"
                marginHeight="0"
                srcDoc={`<style>img {max-width:100%;height:auto;}</style><table width="100%" style="border:none;background-color:#eeeeee;margin:0;"><tr><td><center><table style="width:640px;max-width:640px;border-collapse:collapse;font-family:Arial, Helvetica, sans-serif;font-size:14px;color: #484848;line-height:1.3;background-color: #ffffff;"><tr><td  style="text-align:left;background-color:#fff;border-top:4px solid #007cba;border-bottom:1px solid #ddd;"><table style="width:100%;border-collapse:collapse;font-family:Arial, Helvetica, sans-serif;font-size:14px;color: #484848;line-height:1.3;background-color: #ffffff;"><tr><td style="vertical-align:middle;border:20px solid #ffffff;width:200px;"><a href="https://valerotexasopen.com/benefit-for-children/"><img src="https://vto-qnewmedia2.netdna-ssl.com/assets/img/bfc-logo-100px-height.jpg" width="123" height="100" alt="Valero BFC" style="width:123px;border:none;display:block;padding:0;margin: 0 auto;" /></a></td></tr></table></td></tr><tr><td style="font-weight:normal;text-align:left;"><table style="width:100%;border-collapse:collapse;font-family:Arial, Helvetica, sans-serif;font-size:14px;color: #484848;line-height:1.3;background-color: #ffffff;border:20px solid #ffffff;"><tr><td style="font-weight:normal;text-align:left;">${html}</td></tr></table></td></tr></table></center></td></tr></table></body></html>`}
              ></iframe>

              <div className="form-group">
                <Link to="/admin/email/edit">
                  <i className="fa fa-angle-left" />
                  &nbsp; Back to Editor
                </Link>
              </div>

              <div className="form-group">
                <Input
                  name="subject"
                  label="Subject"
                  reqd={true}
                  value={names.subject || ""}
                  autocomplete="off"
                  update={handleUpdate}
                  errors={errors}
                />

                <Input
                  name="replyto"
                  label="Reply-To Address"
                  reqd={true}
                  value={names.replyto || ""}
                  autocomplete="email"
                  update={handleUpdate}
                  errors={errors}
                />
              </div>

              <div
                className="form-group radios"
                style={{ marginTop: "0", marginBottom: "0" }}
              >
                <Radios
                  label="Select Action:"
                  reqd={true}
                  data={[
                    {
                      name: "action",
                      val: "self",
                      label: "Send test email to myself",
                    },
                    {
                      name: "action",
                      val: "all",
                      label: "Send to sponsor contacts and/or guests",
                    },
                  ]}
                  value={""}
                  click={handleUpdate}
                />
              </div>

              {names.action === "all" && (
                <div
                  className="form-group radios radios-alt"
                  style={{ marginTop: "0", marginLeft: "20px" }}
                >
                  <Checkboxes
                    label=""
                    reqd={false}
                    data={[
                      {
                        name: "contacts",
                        val: "Sponsor Contacts",
                        label: "",
                        disabled: false,
                      },
                      {
                        name: "golf",
                        val: "Guests assigned to Golf",
                        label: "",
                        disabled: false,
                      },
                      {
                        name: "sporting",
                        val: "Guests assigned to Sporting Clays",
                        label: "",
                        disabled: false,
                      },
                      {
                        name: "welcome",
                        val: "Welcome Party Guests",
                        label: "",
                        disabled: false,
                      },
                      {
                        name: "gift",
                        val: "Gift Package Guests",
                        label: "",
                        disabled: false,
                      },
                      {
                        name: "liaisons",
                        val: "Valero Liaisons",
                        label: "",
                        disabled: false,
                      },
                    ]}
                    values={[]}
                    click={handleCheckboxes}
                  />
                </div>
              )}

              {names.action === "self" && (
                <div className="form-group one" style={{ marginTop: "10px" }}>
                  <Input
                    name="emails"
                    label="Recipient Address(es)"
                    reqd={true}
                    value={names.emails || ""}
                    autocomplete="email"
                    update={handleUpdate}
                    errors={errors}
                    note={"Separate multiple emails with a comma"}
                  />
                </div>
              )}

              {/*
              {names.action === "all" &&
                (names.contacts || names.mon || names.wed || names.sat) && (
                  <div className="form-group one" style={{ marginTop: "15px" }}>
                    <h4 style={{ marginBottom: "0" }}>
                      <i className="fa fa-envelope-o" /> &nbsp;
                      {`View Recipient(s)`}
                    </h4>
                  </div>
                )}*/}

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" ? "hidden" : "submit-container"
                  }
                >
                  <Submit submit="Send Email" />
                </div>
              </div>
            </form>

            <div className="spacer"></div>
          </div>

          <div id="right-column">
            <Nav on={0} user={user} />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default EmailSend;
